import React from 'react';

const RestartIcon = ({ color = 'var(--icon-default)', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M4.69605 7.20741L5.2853 6.61815C7.8888 4.01466 12.1099 4.01466 14.7134 6.61815C17.3169 9.22165 17.3169 13.4427 14.7134 16.0462C12.1099 18.6497 7.8888 18.6497 5.2853 16.0462C3.77128 14.5322 3.13772 12.4712 3.3846 10.4993M4.69605 7.20741H8.23158M4.69605 7.20741V3.67188"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default React.forwardRef(RestartIcon);
